export default {
    // 登录用户信息
    userInfo: null,

    // 搜索关键词
    searchKey:null,
    searchList:[],

    // 项目信息
    itemId:null,
    itemType:0,
    nameType:['楼盘','商铺','写字楼','车位'],
    sizeType:['户型','户型','户型','规格'],
    numberType:['房号','商铺号','房号','车位编号'],

    // 模块信息
    modulesAct:null,

    // 设置步骤
    stepKey:'set',

    // 标签
    tagDatas:[
        // 楼盘
        ["商品房","安置房","三产房","集资房公寓","双中心","CBD","CRD","商务集聚区","一线海景区","立体交通","零时差","地铁覆盖","低密度 ","大尺度开间","专属电梯","板楼结构","南北通透","交通便利","周边配套齐全","商业配套齐全","采光好","楼间距大","绿化率高","出房率高"],
        // 商铺
        ["商业临街商铺","写字楼配套","社区底商","临街门面","档口摊位","购物百货中心","添加类型","人流量大","视线好","黄金地段","进货发货方便","独门独户","一位临街","业态安排自由","双中心","CBD","CRD","商务集聚区","一线海景区","立体交通","零时差","地铁覆盖","交通便利","周边配套齐全","商业配套齐全","投资首选","经济实惠","商住两用"],
        // 写字楼
        ["纯写字楼","商业综合体写字楼","商务公寓写字楼","商务酒店写字楼","人流量大","视线好","黄金地段","进货发货方便","独门独户","一位临街","业态安排自由","双中心","CBD","CRD","商务集聚区","一线海景区","立体交通","零时差","地铁覆盖","交通便利","周边配套齐全","商业配套齐全","投资首选","经济实惠","商住两用"],
        // 车位
        ["地上露天车位","地上车库","地下车库","标准车位","人防车位","子母车位","视线好","黄金地段","进货发货方便","一位临街","双中心","CBD","CRD","商务集聚区","立体交通","零时差","地铁覆盖","交通便利","周边配套齐全","商业配套齐全","投资首选","经济实惠"]
    ],

    // 配套
    peitaoDatas:[
        [],
        ["客梯","货梯","中央空调停车位","天然气","电话/网络","暖气","扶梯","上水","下水","排烟","排污","管煤","380V","可明火","外摆区","添加配套"],
        ["宽带","有线电视","水","电","电话","中央空调","电梯","集中供暖","办公家具","免费车位","员工餐厅","安全监控"],
        []
    ]
    
}


// WEBPACK FOOTER //
// ./src/store/state.js